import { css, cx } from "@emotion/css";
import { PropsWithChildren, useContext } from "react";

import { ModalTriggerContext } from "./ModalTrigger";
import { Space } from "../../foundations/grid-layout/Layout";
import { _Heading } from "../../foundations/typography/assets/_Heading";
import { GhostIconButton } from "../button/GhostIconButton";

interface Props extends PropsWithChildren {
  testID?: string;
  hideDivider?: boolean;
  onClose?(): void;
}

export function DialogHeader(props: Props) {
  const { toggle } = useContext(ModalTriggerContext);
  const { hideDivider, onClose = toggle } = props;

  return (
    <div
      className={cx(styles.dialogHeader, hideDivider && styles.hiddenDivider)}
    >
      {typeof props.children === "string" ? (
        <_Heading style="global/modal-header" slot="title">
          {props.children}
        </_Heading>
      ) : (
        props.children
      )}
      <Space />
      <GhostIconButton
        size="small"
        icon="close"
        onPress={onClose}
        testID={props.testID ? `${props.testID}-close-button` : "close-button"}
      />
    </div>
  );
}

const styles = {
  dialogHeader: css({
    alignItems: "center",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    display: "flex",
    flexShrink: 0,
    gap: "var(--space-5)",
    paddingBottom: `calc(${"var(--space-3)"} - 1px)`,
    paddingLeft: "var(--space-5)",
    paddingRight: "var(--space-5)",
    paddingTop: "var(--space-3)",
    borderColor: "var(--border-base)",
  }),
  hiddenDivider: css({ borderBottomWidth: 0 }),
};
